module.exports = __webpack_public_path__ + "static/media/noprofile.1a4202f7.png";